module.exports = __webpack_public_path__ + "src/img/artist/name06.svg?6bae5ced9a45558413e764ba304a7782";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name06.svg
// module id = 142
// module chunks = 0